import AppMenu from "./AppMenu";

export default AppMenu;